module.exports = __webpack_public_path__ + "assets/osaka-bottom-left.a725f48c.svg";